import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import NumberFormat from 'react-number-format';
import { Button } from "@material-ui/core";
import moment from 'moment';

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    pos: {
      marginBottom: 12,
    },
    formControl: {
      margin: theme.spacing.unit,
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    checked: {},
});

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        thousandSeparator
        prefix="£"
      />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

class ClaimENStep2 extends React.Component {
    state = {
        value: 'female',
        incomp: '',
        showEvidence: false,
        showCollege: false,
        showMother: false,
        showBenefit: false,
        showCert: false,
        showLimit: false,
        exemptionName: '',
        fp17data: this.props.fp17data,
        pdata: this.props.pdata,
    };

    componentDidMount() {
        // need to check DOB baased on acceptance date not current date
        let datatmp = this.state.fp17data;
        datatmp["years"] = moment(this.state.fp17data.datacc).diff(moment(this.state.pdata.dob), 'years');
        this.setState({fp17data: datatmp});

        this.parseExemption(this.state.fp17data.exrmcd);
    }

    parseExemption(exval) {
        console.log(this.state);

        this.setState({showEvidence: false, showCollege: false, showMother: false, showBenefit: false, showCert: false, showLimit: false});

        switch (exval) {
            case '8':
                let datatmp = this.state.fp17data;
                datatmp["exrmcd_seen"] = 'Y';
                this.setState({fp17data: datatmp});
                break;
            case '4':
            case '10':
                this.setState({showEvidence: true});
                this.setState({showCert: true});
                break;
            case '5':
                this.setState({showEvidence: true});
                this.setState({showCert: true});
                this.setState({showLimit: true});
                break;
            case '2':
            case '3':
                this.setState({showEvidence: true});
                this.setState({showMother: true});
                break; 
            case '1':
                this.setState({showEvidence: true});
                this.setState({showCollege: true});
                break;  
            case '6':
            case '7':
            case '11':
            case '18':
                this.setState({showEvidence: true});
                this.setState({showBenefit: true});
                break;                    
            default:
                break;
        }
    }

    handleChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let datatmp = this.state.fp17data;
        datatmp[name] = event.target.value;
        this.setState({fp17data: datatmp});        

        if (name === 'exrmcd') {
            this.parseExemption(event.target.value);
        }

        //console.log(this.state);
    };

    addPatientDetails = e => {
        let datatmp = this.state.fp17data;
        datatmp.exemp_person = this.state.pdata.name;
        datatmp.exemp_persondob = this.state.pdata.dob;
        datatmp.exemp_personni = this.state.pdata.ni;
        this.setState({fp17data: datatmp});        
    }

    render() {
        const { classes } = this.props;

        return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                    Part 4 Exemptions and Remissions
                    </Typography>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <RadioGroup
                                    aria-label="Incomplete Treatment"
                                    name="claim-exemption"
                                    className={classes.group}
                                    value={this.state.fp17data.exrmcd}
                                    onChange={this.handleChange('exrmcd')}
                                    row
                                >
                                    <FormControlLabel value="0" control={<Radio classes={{
                                        root: classes.greenradio,
                                        checked: classes.checked,
                                    }}/>} label="No Exemption" />
                                    { this.state.fp17data.years < 18 ?
                                    <FormControlLabel value="8" control={<Radio />} label="Patient under 18" />
                                    : null }
                                    <FormControlLabel value="4" control={<Radio />} label="Full remission - HC2" />
                                    <FormControlLabel value="5" control={<Radio />} label="Partial remission - HC3" />
                                    { this.state.pdata.gender === 'F' ?
                                    <FormControlLabel value="2" control={<Radio />} label="Expectant mother" />
                                    : null }
                                    { this.state.pdata.gender === 'F' ?
                                    <FormControlLabel value="3" control={<Radio />} label="Nursing monther" />
                                    : null}
                                    { this.state.fp17data.years === 18 ?
                                    <FormControlLabel value="1" control={<Radio />} label="Aged 18 in full-time education" />
                                    : null }
                                    <FormControlLabel value="6" control={<Radio />} label="Income Support" />
                                    <FormControlLabel value="10" control={<Radio />} label="NHS Tax Credit Exemption" />
                                    <FormControlLabel value="7" control={<Radio />} label="Income-based Jobseeker's allowance" />
                                    <FormControlLabel value="11" control={<Radio />} label="Pension credit guarantee credit" />   
                                    
                                    <FormControlLabel value="12" control={<Radio />} label="Prisoner" />
                                    <FormControlLabel value="18" control={<Radio />} label="Income-related employment and support allowance" />
                                    <FormControlLabel value="21" control={<Radio />} label="Universal credit" />                                   
                                    
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormLabel  htmlFor="claim-exemptionevidence">Evidence of exemption seen</FormLabel>
                                <RadioGroup
                                    aria-label="Evidence of exemption seen"
                                    name="claim-exemptionevidence"
                                    className={classes.group}
                                    value={this.state.fp17data.exrmcd_seen}
                                    onChange={this.handleChange('exrmcd_seen')}
                                    row
                                >
                                    <FormControlLabel value="Y" control={<Radio checked={this.state.fp17data.exrmcd_seen==='Y'} 
                                    classes={{
                                        root: classes.greenradio,
                                    }}/>} label="Yes" />
                                    <FormControlLabel value="N" control={<Radio checked={this.state.fp17data.exrmcd_seen==='N'} 
                                    classes={{
                                        root: classes.redradio,
                                    }}/>} label="No" />
                                </RadioGroup>
                            </FormControl>                            
                        </Grid>
                    </Grid>
            </Paper>
            { this.state.showEvidence ?
            <Paper className={classes.paper}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                    Exemption supporting evidence
                    </Typography>
                    <Grid container spacing={2}>
                        { this.state.showCollege ?                    
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel htmlFor="claim-exemp_college">Name of college or university</FormLabel>
                                <TextField
                                    value={this.state.fp17data.exemp_college}
                                    onChange={this.handleChange('exemp_college')}
                                    id="claim-exemp_college"
                                />                                
                            </FormControl>                                                        
                        </Grid>
                        : null }
                        { this.state.showMother ?                        
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel htmlFor="claim-exemp_mother">NHS Maternity Exemption Certificate number</FormLabel>
                                <TextField
                                    value={this.state.fp17data.exemp_mother}
                                    onChange={this.handleChange('exemp_mother')}
                                    id="claim-exemp_mother"
                                />                                
                            </FormControl>                                                        
                        </Grid>
                        : null }
                        { this.state.showMother ?                        
                        <Grid item xs={6}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel htmlFor="claim-exemp_born">Baby due / born on date</FormLabel>
                                <TextField
                                    value={this.state.fp17data.exemp_born}
                                    onChange={this.handleChange('exemp_born')}
                                    id="claim-exemp_born"
                                    type="date"
                                />                                
                            </FormControl>                                                        
                        </Grid>
                        : null }
                        { this.state.showBenefit ?                        
                        <Grid item xs={1} md={6}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel htmlFor="claim-exemp_person">Name of person receiving benefit</FormLabel>
                                <TextField
                                    value={this.state.fp17data.exemp_person}
                                    onChange={this.handleChange('exemp_person')}
                                    id="claim-exemp_person"
                                />                                
                            </FormControl>                                                        
                        </Grid>
                        : null }
                        { this.state.showBenefit ?                        
                        <Grid item xs={4}>
                            <Button variant="contained" color="primary" 
                                onClick={this.addPatientDetails}>Use details from current patient</Button>                                                       
                        </Grid>
                        : null }                        
                        { this.state.showBenefit ?
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel htmlFor="claim-exemp_persondob">Date of birth of person receiving benefit</FormLabel>
                                <TextField
                                    value={this.state.fp17data.exemp_persondob}
                                    onChange={this.handleChange('exemp_persondob')}
                                    id="claim-exemp_persondob"
                                    type="date"
                                />                                
                            </FormControl>                                                        
                        </Grid> 
                        : null }
                        { this.state.showBenefit ?  
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel htmlFor="claim-exemp_personni">National Insurance Number person receiving benefit</FormLabel>
                                <TextField
                                    value={this.state.fp17data.exemp_personni}
                                    onChange={this.handleChange('exemp_personni')}
                                    id="claim-exemp_personni"
                                />                                
                            </FormControl>                                                        
                        </Grid>
                        : null }
                        { this.state.showCert ?
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel htmlFor="claim-exemp_certno">Certificate Number or Card Number</FormLabel>
                                <TextField
                                    value={this.state.fp17data.exemp_certno}
                                    onChange={this.handleChange('exemp_certno')}
                                    id="claim-exemp_certno"
                                />                                
                            </FormControl>                                                        
                        </Grid> 
                        : null } 
                        { this.state.showLimit ?
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={false}>
                                <FormLabel htmlFor="claim-exemp_limit">Patient Charge Limit</FormLabel>
                                <TextField
                                    value={this.state.fp17data.exemp_limit}
                                    onChange={this.handleChange('exemp_limit')}
                                    id="claim-exemp_limit"
                                    InputProps={{
                                        inputComponent: NumberFormatCustom,
                                    }}
                                />                                
                            </FormControl>                                                        
                        </Grid>   
                        : null }                                                                                           
                    </Grid>
            </Paper> 
            : null }           
        </div>
        );
    }
}

ClaimENStep2.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ClaimENStep2);